import React, { Fragment } from "react";
import ApproveButton from "./buttons/ApproveButton";
import ChangeStatusButton from "./buttons/ChangeStatusButton";

const BulkActions = (props) => (
  <Fragment>
    <ChangeStatusButton {...props} />
    <ApproveButton {...props} />
  </Fragment>
);
export default BulkActions;
